import React from "react";
import "./style.css";

function Footer() {
  return (
    <footer className="disc">
  <p>
    
      *following items may contain raw or under cooked products. consuming raw seafood or meat may increase your risk of food borne illness, if you have certain medical conditions.
</p>
    </footer>
  );
}

export default Footer;
